import component from './recollect.vue'

export default component
